import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  LIST_VEHICLES,
  CREATE_VEHICLE,
  DELETE_VEHICLE,
  UPDATE_VEHICLE,
  GET_VEHICLE_DETAILS,
  VEHICLE_STATUS_LIST,
  VEHICLE_STATUS_CREATE,
  VEHICLE_STATUS_UPDATE,
  VEHICLE_STATUS_DELETE,
  VEHICLE_TYPE_LIST,
  VEHICLE_TYPE_CREATE,
  VEHICLE_TYPE_UPDATE,
  VEHICLE_TYPE_DELETE,
  VEHICLE_RECENT_ACTIVITY_LIST,
  VEHICLE_SEARCH,
} from "./actionType";

import {
  listVehiclesSuccess,
  listVehiclesFailure,
  createVehicleSuccess,
  createVehicleFailure,
  deleteVehicleSuccess,
  deleteVehicleFailure,
  updateVehicleSuccess,
  updateVehicleFailure,
  getVehicleDetailsSuccess,
  getVehicleDetailsFailure,
  listVehicleStatusSuccess,
  listVehicleStatusFailure,
  createVehicleStatusSuccess,
  createVehicleStatusFailure,
  updateVehicleStatusSuccess,
  updateVehicleStatusFailure,
  deleteVehicleStatusSuccess,
  deleteVehicleStatusFailure,
  listVehicleTypeSuccess,
  listVehicleTypeFailure,
  createVehicleTypeSuccess,
  createVehicleTypeFailure,
  updateVehicleTypeSuccess,
  updateVehicleTypeFailure,
  deleteVehicleTypeSuccess,
  deleteVehicleTypeFailure,
  listVehicleRecentActivitySuccess,
  listVehicleRecentActivityFailure,
  searchVehicleSuccess,
  searchVehicleFailure,
} from "./action";

import {
  listVehiclesApi,
  createVehicleApi,
  deleteVehicleApi,
  updateVehicleApi,
  getVehicleDetailsApi,
  listVehicleStatusApi,
  createVehicleStatusApi,
  updateVehicleStatusApi,
  deleteVehicleStatusApi,
  listVehicleTypeApi,
  createVehicleTypeApi,
  updateVehicleTypeApi,
  deleteVehicleTypeApi,
  listVehicleRecentActivityApi,
  searchVehicleApi,
} from "../../helpers/fakebackend_helper";

// List Vehicles
function* listVehicles() {
  try {
    const response = yield call(listVehiclesApi);
    yield put(listVehiclesSuccess(response));
  } catch (error) {
    yield put(listVehiclesFailure(error));
  }
}

function* listVehiclesWatcher() {
  yield takeEvery(LIST_VEHICLES, listVehicles);
}

// Create Vehicle
function* createVehicle({ payload }) {
  try {
    const response = yield call(createVehicleApi, payload);
    yield put(createVehicleSuccess(response));
  } catch (error) {
    yield put(createVehicleFailure(error));
  }
}

function* createVehicleWatcher() {
  yield takeEvery(CREATE_VEHICLE, createVehicle);
}

// Delete Vehicle
function* deleteVehicle({ payload }) {
  try {
    const response = yield call(deleteVehicleApi, payload);
    yield put(deleteVehicleSuccess(response));
  } catch (error) {
    yield put(deleteVehicleFailure(error));
  }
}

function* deleteVehicleWatcher() {
  yield takeEvery(DELETE_VEHICLE, deleteVehicle);
}

// Update Vehicle
function* updateVehicle({ payload }) {
  try {
    const response = yield call(updateVehicleApi, payload);
    yield put(updateVehicleSuccess(response));
  } catch (error) {
    yield put(updateVehicleFailure(error));
  }
}

function* updateVehicleWatcher() {
  yield takeEvery(UPDATE_VEHICLE, updateVehicle);
}

// Get Vehicle Details
function* getVehicleDetails({ payload }) {
  try {
    const response = yield call(getVehicleDetailsApi, payload);
    yield put(getVehicleDetailsSuccess(response));
  } catch (error) {
    yield put(getVehicleDetailsFailure(error));
  }
}

function* getVehicleDetailsWatcher() {
  yield takeEvery(GET_VEHICLE_DETAILS, getVehicleDetails);
}

// List Vehicle Status
function* listVehicleStatus() {
  try {
    const response = yield call(listVehicleStatusApi);
    yield put(listVehicleStatusSuccess(response));
  } catch (error) {
    yield put(listVehicleStatusFailure(error));
  }
}

function* listVehicleStatusWatcher() {
  yield takeEvery(VEHICLE_STATUS_LIST, listVehicleStatus);
}

// Create Vehicle Status
function* createVehicleStatus({ payload }) {
  try {
    const response = yield call(createVehicleStatusApi, payload);
    yield put(createVehicleStatusSuccess(response));
  } catch (error) {
    yield put(createVehicleStatusFailure(error));
  }
}

function* createVehicleStatusWatcher() {
  yield takeEvery(VEHICLE_STATUS_CREATE, createVehicleStatus);
}

// Update Vehicle Status
function* updateVehicleStatus({ payload }) {
  try {
    const response = yield call(updateVehicleStatusApi, payload);
    yield put(updateVehicleStatusSuccess(response));
  } catch (error) {
    yield put(updateVehicleStatusFailure(error));
  }
}

function* updateVehicleStatusWatcher() {
  yield takeEvery(VEHICLE_STATUS_UPDATE, updateVehicleStatus);
}

// Delete Vehicle Status
function* deleteVehicleStatus({ payload }) {
  try {
    const response = yield call(deleteVehicleStatusApi, payload);
    yield put(deleteVehicleStatusSuccess(response));
  } catch (error) {
    yield put(deleteVehicleStatusFailure(error));
  }
}

function* deleteVehicleStatusWatcher() {
  yield takeEvery(VEHICLE_STATUS_DELETE, deleteVehicleStatus);
}

// List Vehicle Type
function* listVehicleType() {
  try {
    const response = yield call(listVehicleTypeApi);
    yield put(listVehicleTypeSuccess(response));
  } catch (error) {
    yield put(listVehicleTypeFailure(error));
  }
}

function* listVehicleTypeWatcher() {
  yield takeEvery(VEHICLE_TYPE_LIST, listVehicleType);
}

// Create Vehicle Type
function* createVehicleType({ payload }) {
  try {
    const response = yield call(createVehicleTypeApi, payload);
    yield put(createVehicleTypeSuccess(response));
  } catch (error) {
    yield put(createVehicleTypeFailure(error));
  }
}

function* createVehicleTypeWatcher() {
  yield takeEvery(VEHICLE_TYPE_CREATE, createVehicleType);
}

// Update Vehicle Type
function* updateVehicleType({ payload }) {
  try {
    const response = yield call(updateVehicleTypeApi, payload);
    yield put(updateVehicleTypeSuccess(response));
  } catch (error) {
    yield put(updateVehicleTypeFailure(error));
  }
}

function* updateVehicleTypeWatcher() {
  yield takeEvery(VEHICLE_TYPE_UPDATE, updateVehicleType);
}

// Delete Vehicle Type
function* deleteVehicleType({ payload }) {
  try {
    const response = yield call(deleteVehicleTypeApi, payload);
    yield put(deleteVehicleTypeSuccess(response));
  } catch (error) {
    yield put(deleteVehicleTypeFailure(error));
  }
}

function* deleteVehicleTypeWatcher() {
  yield takeEvery(VEHICLE_TYPE_DELETE, deleteVehicleType);
}

// List Vehicle Recent Activity
function* listVehicleRecentActivity({ payload }) {
  try {
    const response = yield call(listVehicleRecentActivityApi, payload);
    yield put(listVehicleRecentActivitySuccess(response));
  } catch (error) {
    yield put(listVehicleRecentActivityFailure(error));
  }
}

function* listVehicleRecentActivityWatcher() {
  yield takeEvery(VEHICLE_RECENT_ACTIVITY_LIST, listVehicleRecentActivity);
}

// Search Vehicle
function* searchVehicle({ payload }) {
  try {
    const response = yield call(searchVehicleApi, payload);
    yield put(searchVehicleSuccess(response));
  } catch (error) {
    yield put(searchVehicleFailure(error));
  }
}

function* searchVehicleWatcher() {
  yield takeEvery(VEHICLE_SEARCH, searchVehicle);
}

export default function* Vehicle() {
  yield all([
    fork(listVehiclesWatcher),
    fork(createVehicleWatcher),
    fork(deleteVehicleWatcher),
    fork(updateVehicleWatcher),
    fork(getVehicleDetailsWatcher),
    fork(listVehicleStatusWatcher),
    fork(createVehicleStatusWatcher),
    fork(updateVehicleStatusWatcher),
    fork(deleteVehicleStatusWatcher),
    fork(listVehicleTypeWatcher),
    fork(createVehicleTypeWatcher),
    fork(updateVehicleTypeWatcher),
    fork(deleteVehicleTypeWatcher),
    fork(listVehicleRecentActivityWatcher),
    fork(searchVehicleWatcher),
  ]);
}
